const GenderEnum = [
    {value:'masculino',label:'Masculino'},
    {value:'femenino',label:'Femenino'},
    {value:'noEspecificado',label:'No especificar'},
  ];

  export default GenderEnum;